import { Consultation, ConsultationCard } from 'types';

export const useShowViewResponse = (
  consultation: Consultation | ConsultationCard | undefined
): boolean => {
  // If a consultation is withdrawn, closed or determined and no response was submitted the view response option will not be available.
  return (
    !!consultation &&
    (!['Withdrawn', 'Closed', 'Determined'].includes(consultation.status) ||
      consultation.hasAnyResponses)
  );
};
